<script>
import Vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import apiEndpoints from "@/services/apiEndpoints";
import store from '@/state/store';

export default {
  components: {
    VueDropzone: Vue2Dropzone
  },
  props: ["isUpdate", "files","disabled"],
  data() {
    return {
      busyGetData: false,
      dropzoneOptions: {
        headers:{"Authorization":'Bearer ' + store.getters['auth/token']},
        thumbnailWidth: 150,
        acceptedFiles: '.jpg, .jpeg, .png, .xlsx, .xlsm, .xls, .pdf, .txt, .docx, .doc, .pptx, .bmp',
        dictDefaultMessage: "",
        addRemoveLinks: true,
        dictRemoveFile:"消去",
        dictCancelUpload:"アップロードをキャンセル",
        dictCancelUploadConfirmation:"このアップロードをキャンセルしてもよろしいですか？",
        dictFileTooBig: "ファイルのサイズは無効です。",
        dictInvalidFileType: "ファイルのフォーマットが無効です。",
        uploadMultiple: true,
        clickable: "#select-file-btn",
        createImageThumbnails: false,
      },
      uploaded: [],
      apiURl: process.env.VUE_APP_API_URL + '/api',
      errorMessage: ""
    };
  },
  created() {
    const url = this.apiURl + apiEndpoints.projects_sales_work_order_upload(this.$route.params.id);
    this.dropzoneOptions.url = url;
  },
  mounted() {
    if (this.isUpdate) {
      let files = this.files;
      let that = this
      files.forEach((item, index) => {
        var file = {size: "", id: item.id, name: item.file_name, upload_file_name: item.upload_file_name, file_name: item.file_name, file_url: item.file_url};
        this.$refs.myVueDropzone.manuallyAddFile(file, item.file_url);
        that.uploaded.push(file);
      })
    }
  },
  methods: {
    hideUpload: function () {
      this.$emit("uploadSelected", this.uploaded);
    },
    vsuccess(files, response) {
      var result = response.result;
      for (var i = 0; i < result.length; i++) {
        const matchFile = files.find(item => item.upload.filename === result[i]['file_name']);
        this.uploaded.push({
          "file_name": result[i]['file_name'],
          "upload_file_name": result[i]['upload_file_name'],
          "file_url": result[i]['file_url'],
          "id": matchFile ? matchFile.upload.uuid : null,
        });
      }
    },
    remove(file, error, xhr) {
      this.uploaded.forEach((item, index) => {
        let isNewUpload = file.id == undefined;
        if((isNewUpload == true && item.id == file.upload.uuid)
          || (isNewUpload == false && item.id == file.id)) {
          this.uploaded.splice(index, 1);
        }
      });
    },
    handleDropzoneError(file, errorMessage, xhr) {
      if (typeof errorMessage === 'string') {
        this.errorMessage = errorMessage;
      } else {
        this.errorMessage = errorMessage.message || '';
      }

      this.$refs.myVueDropzone.removeFile(file);
    },
    handleFileAdded(file) {
      this.errorMessage = '';
    },
  }
};
</script>
<template>
  <div class="mb-2 d-xl-flex">
    <button
      v-b-modal.dropzone-modal
      class="btn btn-primary waves-effect waves-light"
      :disabled="disabled"
    >
      <i class='fas fa-paperclip'></i> 添付ファイルを追加する
    </button>
    <!-- modal area -->
    <b-modal
      size="xl"
      id="dropzone-modal"
      centered
      title-class="font-size-14"
      hide-footer
      scrollable
      title="ファイルを選択したら、☒ボタンを押してください"
      @hide="hideUpload"
      static
    >
      <b-row>
        <b-overlay
          :show="busyGetData"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <VueDropzone
            ref="myVueDropzone"
            id="work_order_upload_dropzone"
            :options="dropzoneOptions"
            @vdropzone-success-multiple="vsuccess"
            @vdropzone-removed-file='remove'
            @vdropzone-error="handleDropzoneError"
            @vdropzone-file-added="handleFileAdded"
          >

          </VueDropzone>
          <div class="select-file-btn d-flex justify-content-center mt-2" id="select-file-btn">
            <b-button variant="primary" size="lg"><i class='fas fa-check'></i> ファイル選択</b-button>
          </div>
        </b-overlay>
      </b-row>
      <div v-if="errorMessage">
        {{ errorMessage }}
      </div>
    </b-modal>
  </div>
</template>
<style lang="scss">
.dz-remove {
  margin-bottom: 110px;
  padding: 2px!important;
  color: red!important;
  border-color: red!important;
  margin-left: 40px!important;
}
#work_order_upload_dropzone {
  .dz-size {
    display: none;
  }
}
</style>
